export type QuoteExcerpt = { id: string; name: string; handle: string; body: string }

export function quoteExcerpt(raw: Record<string, unknown>): QuoteExcerpt {
  const author = (raw.author ?? {}) as Record<string, unknown>
  return { id: String(raw.id), name: String(author.display_name ?? 'Journey90 fan'), handle: `@${String(author.handle ?? 'fan')}`, body: String(raw.body ?? '') }
}

export function followKeys(payload: { members?: Array<Record<string, unknown>>; entities?: Array<Record<string, unknown>> }): Set<string> {
  const keys = new Set<string>()
  for (const member of payload.members ?? []) if (typeof member.id === 'string' && member.id.trim()) keys.add(`member:${member.id}`)
  for (const entity of payload.entities ?? []) {
    if ((entity.type === 'person' || entity.type === 'relationship') && typeof entity.id === 'string' && entity.id.trim()) keys.add(`${entity.type}:${entity.id}`)
  }
  return keys
}

export function sharedPostFromHash(hash: string): string | null {
  const id = hash.startsWith('#post-') ? hash.slice(6) : ''
  return /^[A-Za-z0-9][A-Za-z0-9._:-]{1,127}$/.test(id) ? id : null
}
